export default "__VITE_ASSET__ql_CKDUN__"